import React from 'react';
import $ from 'jquery';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { dateTimeHelper } from '../../Helpers/datetimeHelper.js';
import ClientService from '../../Services/clientService.js';
import LeadService from '../../Services/leadService.js';
import ProjectService from '../../Services/projectService.js';
import OpportunityService from '../../Services/opportunityService.js';
import SurveyService from '../../Services/surveyService.js';
import ListSelector from './listSelector.js';
import timesheet from './timesheet.module.css';
import main from '../main.module.css';
import TimeSheetEntryService from '../../Services/timeSheetEntryService.js';
import JobTitleService from '../../Services/jobTitleService.js';
import { calendarConfig } from './calendarConfig.js';
import SelectLink from './SelectLink.js';
import ItemWindowTypes from '../../Enums/ItemWindowsType.js';
import FaIcon from '../../Elements/FaIcon.js';
import FreelancerUserService from '../../Services/FreelancerUserService.js';
import ErrorMessage from '../../Elements/ErrorMessage.js';
import TpSurveyService from '../../Services/tpSurveyService.js';
import NewProjectService from '../../Services/NewProjectService.js';
import AuthService from '../../Services/authService.js';
import OverWindow from '../../Elements/TabList/OverWindow';
import FigmaButton from '../../Elements/FigmaButton';
import InputWithClear from '../../Elements/InputComponents/InputWithClear';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../Enums/IconPositionEnum';

window.$ = window.jQuery = $;

export default class timeSheetEntryEditor extends React.Component {
  showLabelingTextMaxLength = 23;
  showTaskNameMaxLength = 60;

  constructor(props) {
    super(props);

    const userJobTitleId = JobTitleService.GetUserOfficialJobTitleId();
    const taskList = this.getTaskList(props, userJobTitleId);
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();
    const isOutsourcedEmployee = loggedInUser?.isOutsourcedEmployee === true;
    this.userOfficeId = loggedInUser?.officeId || null;
    this.userOfficeName = loggedInUser?.officeName || '';

    this.state = {
      timesheetEntry: props.timesheetEntry,
      existingTimesheetEntries: props.existingTimesheetEntries,
      taskListLoading: true,
      taskList,
      openLeadSelector: false,
      openServiceTypeSelector: false,
      // IC types for the logged-in user, prefetched on mount so the row can tell
      // "nothing to select" apart from "not loaded yet" (null) before the picker opens.
      serviceTypeOptions: null,
      openClientSelector: false,
      openProjectSelector: false,
      openTpProjectSelector: false,
      openOpportunitySelector: false,
      openSurveySelector: false,
      openTpSurveySelector: false,

      startTimeError: '',
      endTimeError: '',
      endTimeBiggerThanStartTimeError: '',
      dateAffectsOtherWeekError: '',
      startTimeFormatError: '',
      endtTimeFormatError: '',
      overlappingEntriesError: '',
      missingTaskError: '',
      missingCommentError: '',
      missingLeadError: '',
      missingClientError: '',
      missingProjectError: '',
      missingTpProjectError: '',
      missingOpportunityError: '',
      missingSurveyError: '',
      missingTpSurveyError: '',
      notOnlyLeadSelectedError: '',
      // Outsourced employee office selection
      isOutsourcedEmployee,
      noFteEntries: false,
      missingBilledOfficeError: '',
    };

    this.entry = this.state.timesheetEntry;

    this.loadEntryData();

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleIsOutsourcedChange = this.handleIsOutsourcedChange.bind(this);
    this.onDdTaskChange = this.onDdTaskChange.bind(this);
    this.deleteTimesheetEntry = this.deleteTimesheetEntry.bind(this);
    this.copyEntry = this.copyEntry.bind(this);
    this.saveTimesheetEntry = this.saveTimesheetEntry.bind(this);
  }

  getTaskList(props, userJobTitleId) {
    const tasklist = props.taskList.map((r) => ({
      label: r.name,
      value: r.taskId,
      isCommentMandatory: r.isCommentMandatory,
      isLeadMandatory: r.isLeadMandatory,
      isClientMandatory: r.isClientMandatory,
      isProjectMandatory: r.isProjectMandatory,
      isTpProjectMandatory: r.isTpProjectMandatory,
      isOpportunityMandatory: r.isOpportunityMandatory,
      isSurveyMandatory: r.isSurveyMandatory,
      isTpSurveyMandatory: r.isTpSurveyMandatory,
      taskOfficialJobTitles: r.taskOfficialJobTitles,
    }));

    const tasklistFiltered = tasklist.filter((t) => {
      if (t === undefined || t.value === undefined || t.taskOfficialJobTitles === undefined) return false;
      if (t.value === props.timesheetEntry?.taskId) return true; // Always include the currently selected task, even if it doesn't match the job title filter
      const l = t.taskOfficialJobTitles.filter((j) => j.officialJobTitleValue === userJobTitleId).length;
      return l > 0;
    });

    const tasks = [{ value: -1, label: 'Choose one...' }];
    const tasksConcated = tasks.concat(tasklistFiltered);
    // console.log(tasksConcated);
    return tasksConcated;
  }

  GetListSelectorComponent(open, resource, loadFunction, selectedId, selectedLabel, preloadedList) {
    return open ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource={resource}
            loadFunction={loadFunction}
            preloadedList={preloadedList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={selectedId}
            selectedLabel={selectedLabel}
            clientIdFilter={this.entry.clientId}
            surveyIdFilter={this.entry.surveyId}
            tpSurveyIdFilter={this.entry.tpSurveyId}
            projectIdFilter={this.entry.cfId}
            tpProjectIdFilter={this.entry.projectId}
            opportunityIdFilter={this.entry.opportunityId}
          />
        </div>
      </div>
    ) : null;
  }

  getTaskOptions() {
    return this.state.taskList.map((r) => {
      if (r !== undefined && r.label !== undefined) {
        return {
          label:
            r.label.length > this.showTaskNameMaxLength ? (
              <span
                data-toggle='tooltip'
                data-placement='top'
                title={r.label}
              >
                {`${r.label.substring(0, this.showTaskNameMaxLength)}...`}
              </span>
            ) : (
              r.label
            ),
          value: r.value,
          isCommentMandatory: r.isCommentMandatory,
          isLeadMandatory: r.isLeadMandatory,
          isClientMandatory: r.isClientMandatory,
          isProjectMandatory: r.isProjectMandatory,
          isTpProjectMandatory: r.isTpProjectMandatory,
          isOpportunityMandatory: r.isOpportunityMandatory,
          isSurveyMandatory: r.isSurveyMandatory,
          isTpSurveyMandatory: r.isTpSurveyMandatory,
          taskOfficialJobTitles: r.taskOfficialJobTitles,
        };
      }
      return [];
    });
  }

  render() {
    const type = this.entry.id === '' ? ItemWindowTypes.NewItem : ItemWindowTypes.EditItem;

    const leadSelectorComponent = this.GetListSelectorComponent(
      this.state.openLeadSelector,
      'lead',
      LeadService.GetLeadList,
      this.entry.leadId,
      this.entry.leadName
    );

    const serviceTypeSelectorComponent = this.GetListSelectorComponent(
      this.state.openServiceTypeSelector,
      'servicetype',
      FreelancerUserService.GetFreelancerUserServiceTypes,
      this.entry.serviceType,
      this.entry.serviceType,
      this.state.serviceTypeOptions
    );

    const clientSelectorComponent = this.GetListSelectorComponent(
      this.state.openClientSelector,
      'client',
      ClientService.GetClientList,
      this.entry.clientId,
      this.entry.clientName
    );

    const projectSelectorComponent = this.GetListSelectorComponent(
      this.state.openProjectSelector,
      'project',
      ProjectService.GetProjectList,
      this.entry.cfId,
      this.entry.cfName
    );

    const tpProjectSelectorComponent = this.GetListSelectorComponent(
      this.state.openTpProjectSelector,
      'tpproject',
      NewProjectService.GetProjectList,
      this.entry.projectId,
      this.entry.projectName
    );

    const opportunitySelectorComponent = this.GetListSelectorComponent(
      this.state.openOpportunitySelector,
      'opportunity',
      OpportunityService.GetOpportunityList,
      this.entry.opportunityId,
      this.entry.opportunityName
    );

    const surveySelectorComponent = this.GetListSelectorComponent(
      this.state.openSurveySelector,
      'survey',
      SurveyService.GetSurveyList,
      this.entry.surveyId,
      this.entry.surveyName
    );

    const tpSurveySelectorComponent = this.GetListSelectorComponent(
      this.state.openTpSurveySelector,
      'tpsurvey',
      TpSurveyService.GetSurveySelectList,
      this.entry.tpSurveyId,
      this.entry.tpSurveyName
    );

    const windowTitle = type === ItemWindowTypes.NewItem ? 'New Entry' : `Edit Entry (${this.entry.id})`;

    return (
      <OverWindow
        title={windowTitle}
        clickOnCancel={() => {
          this.hideAllTooltip();
          this.props.closeEditorPopup();
        }}
        closeOnClickOutside={true}
        iconName={type === ItemWindowTypes.NewItem ? 'fa-solid fa-magic' : 'fa-solid fa-edit'}
        maxWidth={900}
        className='top-of-boxFigma ow-fit'
      >
        <div className={`bravo-ds ae-editor ${timesheet.newEntryFontsize}`}>
          <div
            className='container-fluid'
            style={{ maxHeight: 'calc(85vh - 80px)', overflowY: 'auto' }}
          >
            {
              //#region Validation messages
            }
            {this.entry.processed === true && (
              <div className={`row ${timesheet.editRow} m-2`}>
                <div className='col-12 errorMessage bg-danger m-0'>
                  This activity tracker entry has been locked by related finance processes, hence the date, the time and
                  the IC type can't be changed anymore.
                </div>
              </div>
            )}
            {this.props.isVendorLinked && (
              <div className={`row ${timesheet.editRow} m-2`}>
                <div className='col-12 errorMessage bg-warning text-dark m-0'>
                  This entry is linked to a Vendor Payment Line Item, so it can't be edited anymore. It is shown as read
                  only.
                </div>
              </div>
            )}
            {this.props.isBambooPtoLocked && (
              <div className={`row ${timesheet.editRow} m-2`}>
                <div className='col-12 errorMessage bg-warning text-dark m-0'>
                  This PTO entry was created automatically from BambooHR. Only HR or Admin users can adjust it.
                </div>
              </div>
            )}
            {this.props.isJiraWorklog && (
              <div className={`row ${timesheet.editRow} m-2`}>
                <div className='col-12 errorMessage bg-warning text-dark m-0'>
                  This entry was created from a Jira worklog. Only the Outsourced Activity field can be edited.
                </div>
              </div>
            )}
            {this.state.overlappingEntriesError && (
              <div className={`row ${timesheet.editRow} m-2`}>
                <div className='col-12 errorMessage bg-danger m-0'>{this.state.overlappingEntriesError}</div>
              </div>
            )}
            {
              //endregion
            }
            {
              //#region Input fields
            }
            <div className={`row ${timesheet.editRow}`}>
              <div
                className='col-12'
                data-toggle='startdateTooltip'
                data-placement='top'
                title=''
              >
                <InputWithClear
                  type={InputTypesEnum.Date}
                  fieldName='startDate'
                  labelText='Start date'
                  value={dateTimeHelper.getDateFromDateString(this.entry.startDate)}
                  dateAsUtc={true}
                  onChange={this.props.isJiraWorklog ? () => {} : (fieldName, date) => this.handleStartDateChange(date)}
                  disableClearButton={true}
                  isInOneRow={true}
                  margin='m-0'
                />
              </div>
            </div>
            <div className={`row ${timesheet.editRow}`}>
              <div
                className='col-6'
                data-toggle='starttimeTooltip'
                data-placement='top'
                title=''
              >
                <InputWithClear
                  type={InputTypesEnum.Time}
                  fieldName='startTime'
                  labelText='Start time'
                  value={this.state.timesheetEntry.startTime}
                  onChange={
                    this.props.isJiraWorklog ? () => {} : (fieldName, newTime) => this.handleStartTimeChange(newTime)
                  }
                  disableClearButton={true}
                  isInOneRow={true}
                  margin='m-0'
                />
              </div>
              <div
                className='col-6'
                data-toggle='endtimeTooltip'
                data-placement='top'
                title=''
              >
                <InputWithClear
                  type={InputTypesEnum.Time}
                  fieldName='endTime'
                  labelText='End time'
                  value={this.state.timesheetEntry.endTime}
                  onChange={
                    this.props.isJiraWorklog ? () => {} : (fieldName, newTime) => this.handleEndTimeChange(newTime)
                  }
                  disableClearButton={true}
                  isInOneRow={true}
                  margin='m-0'
                />
              </div>
            </div>
            <div className={`row ${timesheet.editRow}`}>
              <div
                className='col-12'
                data-toggle='taskTooltip'
                data-placement='top'
                title=''
              >
                <InputWithClear
                  type={InputTypesEnum.Select}
                  fieldName='taskId'
                  showSelectFilterAt={1}
                  labelText={
                    <span>
                      Task
                      <a
                        className=' m-1'
                        href='https://bareinternational.atlassian.net/servicedesk/customer/portal/6/article/671973390'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <FaIcon
                          iconName='fa-solid fa-circle-info'
                          tooltipText='Click here for more information.'
                        />
                      </a>
                    </span>
                  }
                  value={this.entry.taskId}
                  selectValues={this.getTaskOptions()}
                  onChange={
                    this.props.isJiraWorklog
                      ? () => {}
                      : (fieldName, newValue) => {
                          const task = this.state.taskList.find((t) => t.value === newValue);
                          this.onDdTaskChange({ value: newValue, label: task ? task.label : '' });
                        }
                  }
                  placeholder={this.state.taskList.length > 1 ? 'Please select' : 'Loading...'}
                  isInOneRow={true}
                  margin='m-0'
                  disableClearButton={true}
                />
              </div>
            </div>
            <div className={`row ${timesheet.editRow}`}>
              <div
                className='col-12'
                data-toggle='commentTooltip'
                data-placement='top'
                title=''
              >
                <InputWithClear
                  type={InputTypesEnum.Text}
                  fieldName='comment'
                  labelText='Comment'
                  value={this.entry.comment}
                  onChange={
                    this.props.isJiraWorklog
                      ? () => {}
                      : (fieldName, newValue) => this.handleCommentChange({ target: { value: newValue } })
                  }
                  isInOneRow={true}
                  margin='m-0'
                  disableClearButton={true}
                />
              </div>
            </div>

            <div className={`row ${timesheet.editRow}`}>
              <div className='col-12'>
                <InputWithClear
                  type={InputTypesEnum.OnOff}
                  fieldName='isOutsourced'
                  labelText='Outsourced Activity?'
                  value={this.entry.isOutsourced}
                  onChange={(fieldName, newValue) => this.handleIsOutsourcedChange({ target: { checked: newValue } })}
                  isInOneRow={true}
                  margin='m-0'
                  disableClearButton={true}
                />
              </div>
            </div>

            {/* Outsourced EMPLOYEE billed office (sourced from FTE entries). Hidden when the
               "Outsourced Activity?" checkbox is ticked — the opportunity-based selector below takes precedence. */}
            {this.state.isOutsourcedEmployee && !this.entry.isOutsourced && (
              <div className={`row ${timesheet.editRow}`}>
                <div className='col-12'>
                  <InputWithClear
                    type={InputTypesEnum.BilledOfficeSelect}
                    fieldName='billedOfficeId'
                    labelText='Billed Office *'
                    value={this.entry.billedOfficeId}
                    changeOfEditedMultipItem={(changes) => {
                      changes.forEach((change) => {
                        this.entry[change.fieldName] = change.newValue;
                      });
                      this.setState({ timesheetEntry: { ...this.entry }, missingBilledOfficeError: '' });
                    }}
                    startDate={this.entry.startDate}
                    onNoFteEntries={(noFte) => this.setState({ noFteEntries: noFte })}
                    userOfficeName={this.userOfficeName}
                    isInOneRow={true}
                    margin='m-0'
                    disableClearButton={true}
                  />
                </div>
              </div>
            )}

            {/* Outsourced ACTIVITY billed office: only shown when the checkbox is ticked. The office list is
               narrowed by the entry's labelling - the backend does the resolving, see
               TimesheetEntryService.GetOutsourcedActivityOfficeOptionsAsync. */}
            {this.entry.isOutsourced && (
              <div className={`row ${timesheet.editRow}`}>
                <div
                  className='col-12'
                  data-toggle='billedOfficeTooltip'
                  data-placement='top'
                  title=''
                >
                  <InputWithClear
                    type={InputTypesEnum.OutsourcedActivityOfficeSelect}
                    fieldName='billedOfficeId'
                    labelText='Billed Office *'
                    tooltipText={
                      'The offices on offer narrow as you label the entry, and the most specific label wins. ' +
                      "A Lead offers only that lead's office, and none at all when the lead has no office. " +
                      'A Project offers its fieldwork office. An Opportunity offers the offices of its pricings. ' +
                      'A Client offers the offices of its won opportunities and of those opportunities’ pricings. ' +
                      'With nothing labelled, every office is on offer. Your own office cannot be billed, ' +
                      'because an outsourced activity is billed to the office the work is done for.'
                    }
                    value={this.entry.billedOfficeId}
                    changeOfEditedMultipItem={(changes) => {
                      changes.forEach((change) => {
                        this.entry[change.fieldName] = change.newValue;
                      });
                      this.setState({ timesheetEntry: { ...this.entry }, missingBilledOfficeError: '' });
                    }}
                    labelling={{
                      leadId: this.entry.leadId,
                      clientId: this.entry.clientId,
                      opportunityId: this.entry.opportunityId,
                      clientFeeId: this.entry.cfId,
                      tpProjectId: this.entry.projectId,
                    }}
                    isInOneRow={true}
                    margin='m-0'
                    disableClearButton={true}
                  />
                </div>
              </div>
            )}
            {/* SelectLink components: No equivalent in InputWithClear.
               These use a custom ListSelector popup pattern with cross-entity filtering logic
               (e.g. selecting a Lead disables Client/Project/etc.). InputTypesEnum has entity selects
               like LeadSelect, ClientSelect, SurveySelect but they are inline dropdowns that
               don't support the bidirectional lock/unlock and cascading auto-fill behavior. */}
            <div className='ae-links'>
              <SelectLink
                labelText='Lead'
                style={{
                  color: this.entry.clientId ? 'darkgray' : '',
                }}
                onClick={() =>
                  this.setState({
                    openLeadSelector: !this.entry.clientId,
                  })
                }
                shownName={this.entry.leadName}
                dataToggle='leadTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('lead');
                  this.validateLead();
                  this.validateNotOnlyLeadSelectedError();
                }}
              />
              {/* Unset shows Select… like the other rows; the empty value still MEANS
                  "Contractor univoiceable" — that label is shown (muted, locked) only when
                  the prefetch found no IC types to pick, so opening the picker is pointless.
                  While the prefetch is pending (null) stay optimistic: the picker fetches
                  its own list as before. */}
              <SelectLink
                labelText='IC Type'
                onClick={() => this.setState({ openServiceTypeSelector: true })}
                shownName={
                  this.state.serviceTypeOptions !== null &&
                  this.state.serviceTypeOptions.length === 0 &&
                  this.entry.serviceType === ''
                    ? 'Contractor univoiceable'
                    : this.entry.serviceType
                }
                dataToggle='leadTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('servicetype');
                }}
                disabled={this.state.serviceTypeOptions !== null && this.state.serviceTypeOptions.length === 0}
              />
              <SelectLink
                labelText='Client'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) ||
                    this.entry.cfId ||
                    this.entry.projectId ||
                    this.entry.surveyId ||
                    this.entry.tpSurveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openClientSelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) &&
                      !this.entry.cfId &&
                      !this.entry.projectId &&
                      !this.entry.surveyId &&
                      !this.entry.tpSurveyId,
                  })
                }
                shownName={this.entry.clientName}
                dataToggle='clientTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('client');
                  this.validateClient();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={
                  this.props.isJiraWorklog ||
                  !!this.entry.cfId ||
                  !!this.entry.projectId ||
                  !!this.entry.surveyId ||
                  !!this.entry.tpSurveyId
                }
              />
              <SelectLink
                labelText='Opportunity'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) ||
                    this.entry.cfId ||
                    this.entry.projectId ||
                    this.entry.surveyId ||
                    this.entry.tpSurveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openOpportunitySelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) &&
                      !this.entry.cfId &&
                      !this.entry.projectId &&
                      !this.entry.surveyId &&
                      !this.entry.tpSurveyId,
                  })
                }
                shownName={this.entry.opportunityName}
                dataToggle='opportunityTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('opportunity');
                  this.validateOpportunity();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={
                  this.props.isJiraWorklog ||
                  !!this.entry.cfId ||
                  !!this.entry.projectId ||
                  !!this.entry.surveyId ||
                  !!this.entry.tpSurveyId
                }
              />
              <SelectLink
                labelText='Project'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) || this.entry.projectId || this.entry.tpSurveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openProjectSelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) &&
                      !this.entry.projectId &&
                      !this.entry.tpSurveyId,
                  })
                }
                shownName={this.entry.cfName}
                dataToggle='projectTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('project');
                  this.validateProject();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={this.props.isJiraWorklog}
              />
              <SelectLink
                labelText='TP Project'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) || this.entry.cfId || this.entry.surveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openTpProjectSelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) && !this.entry.cfId && !this.entry.surveyId,
                  })
                }
                shownName={this.entry.projectName}
                dataToggle='tpProjectTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('tpproject');
                  this.validateTpProject();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={this.props.isJiraWorklog}
              />
              <SelectLink
                labelText='Survey'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) || this.entry.projectId || this.entry.tpSurveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openSurveySelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) &&
                      !this.entry.projectId &&
                      !this.entry.tpSurveyId,
                  })
                }
                shownName={this.entry.surveyName}
                dataToggle='surveyTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('survey');
                  this.validateSurvey();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={this.props.isJiraWorklog}
              />
              <SelectLink
                labelText='TP Survey'
                style={{
                  color:
                    (this.entry.leadId && this.entry.leadId !== -1) || this.entry.cfId || this.entry.surveyId
                      ? 'darkgray'
                      : '',
                }}
                onClick={() =>
                  this.setState({
                    openTpSurveySelector:
                      !(this.entry.leadId && this.entry.leadId !== -1) && !this.entry.cfId && !this.entry.surveyId,
                  })
                }
                shownName={this.entry.tpSurveyName}
                dataToggle='tpsurveyTooltip'
                deselectOnClick={() => {
                  this.clearLabelling('tpsurvey');
                  this.validateTpSurvey();
                  this.validateNotOnlyLeadSelectedError();
                }}
                disabled={this.props.isJiraWorklog}
              />
            </div>
          </div>
          {
            //endregion
          }
          {
            //#region Button row
          }
          <div className='EditBoxFooter'>
            <div className='EditBoxFooterLeft'>
              <FigmaButton
                label='Cancel'
                type={ButtonTypeEnum.NormalNormal}
                color={ButtonColorsEnum.Common}
                iconPosition={IconPositionEnum.None}
                iconName='fa-solid fa-clone'
                onClick={() => {
                  this.hideAllTooltip();
                  this.props.closeEditorPopup();
                }}
              />
              <FigmaButton
                label='Copy'
                type={ButtonTypeEnum.NormalIconLeft}
                color={ButtonColorsEnum.Common}
                iconPosition={IconPositionEnum.Left}
                iconName='fa-solid fa-clone'
                disabled={
                  !this.entry.id || !this.props.editingEnabled || this.props.isJiraWorklog || this.isOtherUsersEntry()
                }
                onClick={() => this.copyEntry()}
              />
              <FigmaButton
                label='Delete'
                type={ButtonTypeEnum.NormalIconLeft}
                color={ButtonColorsEnum.Destruct}
                iconPosition={IconPositionEnum.Left}
                iconName='fa-solid fa-trash-can'
                disabled={
                  this.entry.processed ||
                  !this.entry.id ||
                  !this.props.editingEnabled ||
                  this.props.isJiraWorklog ||
                  this.props.isVendorLinked
                }
                onClick={() =>
                  ErrorMessage.SetApprove('Are you sure you want to delete this entry?', this.deleteTimesheetEntry)
                }
              />
            </div>
            <div className='EditBoxFooterRight'>
              <FigmaButton
                label='Save'
                type={ButtonTypeEnum.NormalIconLeft}
                color={ButtonColorsEnum.Primary}
                iconPosition={IconPositionEnum.Left}
                iconName='fa-solid fa-circle-check'
                onClick={() => this.saveTimesheetEntry()}
                disabled={!this.props.editingEnabled || this.entry.processed || this.props.isVendorLinked}
              />
            </div>
          </div>
          {
            //#endregion
          }

          {leadSelectorComponent}
          {serviceTypeSelectorComponent}
          {clientSelectorComponent}
          {projectSelectorComponent}
          {tpProjectSelectorComponent}
          {opportunitySelectorComponent}
          {surveySelectorComponent}
          {tpSurveySelectorComponent}
        </div>
      </OverWindow>
    );
  }

  componentDidMount() {
    // The IC Type list is user-scoped only (no filters), so it cannot change while the
    // editor is open — prefetch it once to drive the row display and prefill the picker.
    // On failure stay at null: the row keeps the optimistic Select… link and the picker
    // falls back to its own click-time fetch.
    FreelancerUserService.GetFreelancerUserServiceTypes()
      .then((result) => this.setState({ serviceTypeOptions: result || [] }))
      .catch(() => {});

    this.validateOverlappingEntries();
    this.validateTask();
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="startdateTooltip"]').tooltip();
    $('[data-toggle="enddateTooltip"]').tooltip();
    $('[data-toggle="starttimeTooltip"]').tooltip();
    $('[data-toggle="endtimeTooltip"]').tooltip();
    $('[data-toggle="commentTooltip"]').tooltip();
    $('[data-toggle="taskTooltip"]').tooltip();
    $('[data-toggle="leadTooltip"]').tooltip();
    $('[data-toggle="clientTooltip"]').tooltip();
    $('[data-toggle="projectTooltip"]').tooltip();
    $('[data-toggle="tpProjectTooltip"]').tooltip();
    $('[data-toggle="opportunityTooltip"]').tooltip();
    $('[data-toggle="surveyTooltip"]').tooltip();
    $('[data-toggle="tpsurveyTooltip"]').tooltip();
    $('[data-toggle="billedOfficeTooltip"]').tooltip();

    window.getSelection().empty();
  }

  componentDidUpdate(prevProps) {
    $('[data-toggle="tooltip"]').tooltip();
    if (prevProps.taskList === this.props.taskList) {
      return;
    }
    const userJobTitleId = JobTitleService.GetUserOfficialJobTitleId();
    const taskList = this.getTaskList(this.props, userJobTitleId);
    this.setState({ taskList });
  }

  componentWillUnmount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      taskList: [{ value: -1, label: '' }].concat(nextProps.taskList).map((r) => ({
        label: r.name,
        value: r.taskId,
        isCommentMandatory: r.isCommentMandatory,
        isLeadMandatory: r.isLeadMandatory,
        isClientMandatory: r.isClientMandatory,
        isProjectMandatory: r.isProjectMandatory,
        isTpProjectMandatory: r.isTpProjectMandatory,
        isOpportunityMandatory: r.isOpportunityMandatory,
        isSurveyMandatory: r.isSurveyMandatory,
        isTpSurveyMandatory: r.isTpSurveyMandatory,
        taskOfficialJobTitles: r.taskOfficialJobTitles,
      })),
      existingTimesheetEntries: nextProps.existingTimesheetEntries,
    });
    this.validateOverlappingEntries();
    this.validateTask();
  }

  closeSelectorPopup() {
    this.setState({
      openLeadSelector: false,
      openClientSelector: false,
      openProjectSelector: false,
      openTpProjectSelector: false,
      openOpportunitySelector: false,
      openSurveySelector: false,
      openTpSurveySelector: false,
    });
  }

  selectedResourceChangeCallback = (selectedResource) => {
    const modifiedTimeSheetEntry = this.entry;

    console.log('selectedResource', selectedResource);
    switch (selectedResource.resourceType) {
      case 'lead':
        this.setState({ openLeadSelector: false });
        if (modifiedTimeSheetEntry.leadId === selectedResource.value) return;
        modifiedTimeSheetEntry.leadName = selectedResource.label;
        modifiedTimeSheetEntry.leadId = selectedResource.value;
        break;
      case 'servicetype':
        this.setState({ openServiceTypeSelector: false });
        if (modifiedTimeSheetEntry.serviceType === selectedResource.value) return;
        modifiedTimeSheetEntry.serviceType = selectedResource.value;
        break;
      case 'client':
        this.setState({ openClientSelector: false });
        if (modifiedTimeSheetEntry.clientId === selectedResource.value) return;
        modifiedTimeSheetEntry.clientName = selectedResource.label;
        modifiedTimeSheetEntry.clientId = selectedResource.value;

        modifiedTimeSheetEntry.cfId = null;
        modifiedTimeSheetEntry.cfName = '';
        modifiedTimeSheetEntry.projectId = null;
        modifiedTimeSheetEntry.projectName = '';
        modifiedTimeSheetEntry.opportunityId = null;
        modifiedTimeSheetEntry.opportunityName = '';
        modifiedTimeSheetEntry.surveyId = null;
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        break;
      case 'opportunity':
        this.setState({ openOpportunitySelector: false });
        if (modifiedTimeSheetEntry.opportunityId === selectedResource.value) return;
        modifiedTimeSheetEntry.opportunityName = selectedResource.label;
        modifiedTimeSheetEntry.opportunityId = selectedResource.value;

        modifiedTimeSheetEntry.surveyId = null;
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        modifiedTimeSheetEntry.cfId = null;
        modifiedTimeSheetEntry.cfName = '';
        modifiedTimeSheetEntry.projectId = null;
        modifiedTimeSheetEntry.projectName = '';
        if (selectedResource.value == null || modifiedTimeSheetEntry.clientId != null) {
          return;
        }

        ClientService.GetClientList(null, null, null, selectedResource.value)
          .then((result) => {
            if (!(result !== undefined && result.length !== 0)) {
              return;
            }
            modifiedTimeSheetEntry.clientName = result[0].name;
            modifiedTimeSheetEntry.clientId = result[0].clientId;
            this.setState({
              timesheetEntry: modifiedTimeSheetEntry,
            });
            this.validateClient();
          })
          .catch((error) => ErrorMessage.SetErrorMessage('TSEE722'));
        break;
      case 'project':
        this.setState({ openProjectSelector: false });
        if (modifiedTimeSheetEntry.cfId === selectedResource.value) return;
        modifiedTimeSheetEntry.cfName = selectedResource.label;
        modifiedTimeSheetEntry.cfId = selectedResource.value;

        modifiedTimeSheetEntry.surveyId = null;
        modifiedTimeSheetEntry.surveyName = '';
        if (selectedResource.value == null || modifiedTimeSheetEntry.opportunityId != null) {
          return;
        }

        OpportunityService.GetOpportunityList(null, null, selectedResource.value)
          .then((oppresult) => {
            if (!(oppresult !== undefined && oppresult.length !== 0)) {
              return;
            }
            modifiedTimeSheetEntry.opportunityName = oppresult[0].name;
            modifiedTimeSheetEntry.opportunityId = oppresult[0].opportunityId;
            this.setState({
              timesheetEntry: modifiedTimeSheetEntry,
            });
            this.validateOpportunity();

            ClientService.GetClientList(null, null, selectedResource.value, oppresult[0].opportunityId)
              .then((ccresult) => {
                if (!(ccresult !== undefined && ccresult.length !== 0)) {
                  return;
                }
                modifiedTimeSheetEntry.clientName = ccresult[0].name;
                modifiedTimeSheetEntry.clientId = ccresult[0].clientId;
                this.setState({
                  timesheetEntry: modifiedTimeSheetEntry,
                });
                this.validateClient();
              })
              .catch((error) => ErrorMessage.SetErrorMessage('TSEE750'));
          })
          .catch((error) => ErrorMessage.SetErrorMessage('TSEE763'));

        break;
      case 'tpproject':
        this.setState({ openTpProjectSelector: false });
        if (modifiedTimeSheetEntry.projectId === selectedResource.value) return;
        modifiedTimeSheetEntry.projectName = selectedResource.label;
        modifiedTimeSheetEntry.projectId = selectedResource.value;

        modifiedTimeSheetEntry.tpSurveyId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        if (selectedResource.value == null || modifiedTimeSheetEntry.opportunityId != null) {
          return;
        }

        OpportunityService.GetOpportunityList(null, null, null, null, null, selectedResource.value)
          .then((oppresult) => {
            if (!(oppresult !== undefined && oppresult.length !== 0)) {
              return;
            }
            modifiedTimeSheetEntry.opportunityName = oppresult[0].name;
            modifiedTimeSheetEntry.opportunityId = oppresult[0].opportunityId;
            this.setState({
              timesheetEntry: modifiedTimeSheetEntry,
            });
            this.validateOpportunity();

            ClientService.GetClientList(null, null, null, oppresult[0].opportunityId, null, selectedResource.value)
              .then((ccresult) => {
                if (!(ccresult !== undefined && ccresult.length !== 0)) {
                  return;
                }
                modifiedTimeSheetEntry.clientName = ccresult[0].name;
                modifiedTimeSheetEntry.clientId = ccresult[0].clientId;
                this.setState({
                  timesheetEntry: modifiedTimeSheetEntry,
                });
                this.validateClient();
              })
              .catch((error) => ErrorMessage.SetErrorMessage('TSEE787'));
          })
          .catch((error) => ErrorMessage.SetErrorMessage('TSEE800'));
        break;
      case 'survey':
        this.setState({ openSurveySelector: false });
        if (modifiedTimeSheetEntry.surveyId === selectedResource.value) return;
        modifiedTimeSheetEntry.surveyName = selectedResource.label;
        modifiedTimeSheetEntry.surveyId = selectedResource.value;
        if (selectedResource.value == null || modifiedTimeSheetEntry.cfId != null) {
          return;
        }

        ProjectService.GetProjectList(null, null, null, null, selectedResource.value)
          .then((cfresult) => {
            if (!(cfresult !== undefined && cfresult.length !== 0)) {
              return;
            }
            modifiedTimeSheetEntry.cfId = cfresult[0].cfId;
            modifiedTimeSheetEntry.cfName = cfresult[0].cfName;
            this.setState({
              timesheetEntry: modifiedTimeSheetEntry,
            });

            this.validateProject();

            OpportunityService.GetOpportunityList(null, null, cfresult[0].cfId, null, selectedResource.value)
              .then((oppresult) => {
                if (!(oppresult !== undefined && oppresult.length !== 0)) {
                  return;
                }
                modifiedTimeSheetEntry.opportunityName = oppresult[0].name;
                modifiedTimeSheetEntry.opportunityId = oppresult[0].opportunityId;
                this.setState({
                  timesheetEntry: modifiedTimeSheetEntry,
                });

                this.validateOpportunity();

                ClientService.GetClientList(
                  null,
                  null,
                  cfresult[0].cfId,
                  oppresult[0].opportunityId,
                  selectedResource.value
                )
                  .then((ccresult) => {
                    if (!(ccresult !== undefined && ccresult.length !== 0)) {
                      return;
                    }
                    modifiedTimeSheetEntry.clientName = ccresult[0].name;
                    modifiedTimeSheetEntry.clientId = ccresult[0].clientId;
                    this.setState({
                      timesheetEntry: modifiedTimeSheetEntry,
                    });

                    this.validateClient();
                  })
                  .catch((error) => ErrorMessage.SetErrorMessage('TSEE828'));
              })
              .catch((error) => ErrorMessage.SetErrorMessage('TSEE841'));
          })
          .catch((error) => ErrorMessage.SetErrorMessage('TSEE854'));
        break;
      case 'tpsurvey':
        this.setState({ openTpSurveySelector: false });
        if (modifiedTimeSheetEntry.tpSurveyId === selectedResource.value) return;
        modifiedTimeSheetEntry.tpSurveyId = selectedResource.value;
        modifiedTimeSheetEntry.tpSurveyName = selectedResource.label;
        if (selectedResource.value == null || modifiedTimeSheetEntry.projectId != null) {
          return;
        }

        NewProjectService.GetProjectList(null, null, null, null, null, null, selectedResource.value)
          .then((prresult) => {
            if (!(prresult !== undefined && prresult.length !== 0)) {
              return;
            }
            modifiedTimeSheetEntry.projectId = prresult[0].projectId;
            modifiedTimeSheetEntry.projectName = prresult[0].projectName;
            this.setState({
              timesheetEntry: modifiedTimeSheetEntry,
            });

            this.validateTpProject();

            OpportunityService.GetOpportunityList(
              null,
              null,
              null,
              null,
              null,
              prresult[0].projectId,
              selectedResource.value
            )
              .then((oppresult) => {
                if (!(oppresult !== undefined && oppresult.length !== 0)) {
                  return;
                }
                modifiedTimeSheetEntry.opportunityName = oppresult[0].name;
                modifiedTimeSheetEntry.opportunityId = oppresult[0].opportunityId;
                this.setState({
                  timesheetEntry: modifiedTimeSheetEntry,
                });

                this.validateOpportunity();

                ClientService.GetClientList(
                  null,
                  null,
                  null,
                  oppresult[0].opportunityId,
                  null,
                  prresult[0].projectId,
                  selectedResource.value
                )
                  .then((ccresult) => {
                    if (!(ccresult !== undefined && ccresult.length !== 0)) {
                      return;
                    }
                    modifiedTimeSheetEntry.clientName = ccresult[0].name;
                    modifiedTimeSheetEntry.clientId = ccresult[0].clientId;
                    this.setState({
                      timesheetEntry: modifiedTimeSheetEntry,
                    });

                    this.validateClient();
                  })
                  .catch((error) => ErrorMessage.SetErrorMessage('TSEE877'));
              })
              .catch((error) => ErrorMessage.SetErrorMessage('TSEE890'));
          })
          .catch((error) => ErrorMessage.SetErrorMessage('TSEE903'));
        break;
      case 'isoutsourced':
        break;
      default:
        break;
    }

    this.setState({ timesheetEntry: { ...modifiedTimeSheetEntry } });

    this.validateAllLabelling(selectedResource.resourceType);
  };

  loadEntryData() {
    if (this.entry.leadId !== null) {
      LeadService.GetLeadList(this.entry.leadId)
        .then((result) => {
          const modifiedTimeSheetEntry = this.entry;
          modifiedTimeSheetEntry.leadName = result.companyName;

          this.setState({
            timesheetEntry: modifiedTimeSheetEntry,
          });
          this.validateLead();
        })
        .catch((error) => ErrorMessage.SetErrorMessage('TSEE932'));
    }
  }

  loadOutsourcedOfficeOptions() {
    // Handled by the BilledOfficeSelect input element (reloads on startDate change)
  }

  handleStartDateChange(date) {
    const modifiedTimesheetEntry = this.entry;

    modifiedTimesheetEntry.startDate = dateTimeHelper.getFormattedDate(new Date(date), '.');
    modifiedTimesheetEntry.endDate = dateTimeHelper.getFormattedDate(new Date(date), '.');

    if (date > new Date(this.entry.endDate)) {
      modifiedTimesheetEntry.endDate = dateTimeHelper.getFormattedDate(new Date(date), '.');
    }

    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      if (!this.validateDateRange() && !this.validateOverlappingEntries()) this.validateDateAffectsOtherWeek();
      this.loadOutsourcedOfficeOptions();
    });
  }

  handleEndDateChange(date) {
    const modifiedTimesheetEntry = this.entry;
    modifiedTimesheetEntry.endDate = dateTimeHelper.getFormattedDate(new Date(date), '.');

    if (date < new Date(this.entry.startDate)) {
      modifiedTimesheetEntry.startDate = dateTimeHelper.getFormattedDate(new Date(date), '.');
    }

    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      if (!this.validateDateRange() && !this.validateOverlappingEntries()) this.validateDateAffectsOtherWeek();
    });
  }

  handleStartTimeChange(date) {
    const modifiedTimesheetEntry = this.entry;

    if (dateTimeHelper.isItAValidTime(date)) {
      const hours = `0${dateTimeHelper.getHoursFromTimeString(date)}`.slice(-2);
      const minutes = `0${dateTimeHelper.getMinutesFromTimeString(date)}`.slice(-2);
      modifiedTimesheetEntry.startTime = `${hours}:${minutes}`;

      if (
        dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.startTime) >=
        dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.endTime)
      ) {
        modifiedTimesheetEntry.endTime = dateTimeHelper.convertMinutesToTime(
          dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.startTime) + 30
        );
      }
    } else {
      modifiedTimesheetEntry.startTime = date;
    }
    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      if (!this.validateStartTimeFormat() && !this.validateStartTime() && !this.validateEndTimeBiggerThanStartTime())
        this.validateOverlappingEntries();
    });
  }

  handleEndTimeChange(date) {
    const modifiedTimesheetEntry = this.entry;

    if (dateTimeHelper.isItAValidTime(date)) {
      const hours = `0${dateTimeHelper.getHoursFromTimeString(date)}`.slice(-2);
      const minutes = `0${dateTimeHelper.getMinutesFromTimeString(date)}`.slice(-2);

      modifiedTimesheetEntry.endTime = `${hours}:${minutes}`;

      if (
        dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.endTime) <=
        dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.startTime)
      ) {
        modifiedTimesheetEntry.startTime = dateTimeHelper.convertMinutesToTime(
          dateTimeHelper.convertTimeToMinutes(modifiedTimesheetEntry.endTime) - 30
        );
      }
    } else {
      modifiedTimesheetEntry.endTime = date;
    }

    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      if (!this.validateEndTimeFormat() && !this.validateEndTime() && !this.validateEndTimeBiggerThanStartTime())
        this.validateOverlappingEntries();
    });
  }

  handleCommentChange(e) {
    const modifiedTimesheetEntry = this.entry;
    modifiedTimesheetEntry.comment = e.target.value;
    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      this.validateComment();
    });
  }

  handleIsOutsourcedChange(e) {
    const modifiedTimesheetEntry = this.entry;
    modifiedTimesheetEntry.isOutsourced = e.target.checked;

    // No billed office is pre-filled here: OutsourcedActivityOfficeSelect resolves the list and its default from
    // the entry's labelling as soon as it mounts. (It used to default to the user's own office, which is the one
    // office an outsourced activity can never be billed to - see validateBilledOffice.)

    this.setState({ timesheetEntry: modifiedTimesheetEntry });
  }

  onDdTaskChange(e) {
    const modifiedTimesheetEntry = this.entry;
    modifiedTimesheetEntry.taskId = e.value;
    modifiedTimesheetEntry.taskName = e.label;
    this.setState({ timesheetEntry: modifiedTimesheetEntry }, () => {
      if (!this.validateTask()) this.validateAllLabelling();
    });
    $('[data-toggle="taskTooltip"]').tooltip('hide');
  }

  validateDateRange() {
    let error = '';

    if (dateTimeHelper.getDateFromDateString(this.entry.startDate) < new Date(2000, 1, 1)) {
      error = 'Start date have to be later than 2000-01-01.';
      this.changePopupTextAndFlash('startdateTooltip', error);
      this.setState({ dateRangeError: error });
    }

    if (dateTimeHelper.getDateFromDateString(this.entry.endDate) < new Date(2000, 1, 1)) {
      error = 'End date have to be later than 2000-01-01.';
      this.changePopupTextAndFlash('enddateTooltip', error);
      this.setState({ dateRangeError: error });
    }

    if (
      dateTimeHelper.getDateFromDateString(this.entry.startDate).getFullYear() !==
        dateTimeHelper.getDateFromDateString(this.entry.endDate).getFullYear() ||
      dateTimeHelper.getWeekOfYearForTimeSheet(this.entry.startDate) !==
        dateTimeHelper.getWeekOfYearForTimeSheet(this.entry.endDate)
    ) {
      error = 'Start and End dates have to be on the same week.';
      this.changePopupTextAndFlash('enddateTooltip', error);
      this.setState({ dateRangeError: error });
    }

    if (error !== '') {
      return error;
    }

    if (
      dateTimeHelper.getDateFromDateString(this.entry.startDate) >
      dateTimeHelper.getDateFromDateString(this.entry.endDate)
    ) {
      error = 'End date must be later than start date';
      this.changePopupTextAndFlash('startdateTooltip', error);
      this.changePopupTextAndFlash('enddateTooltip', error);
    } else {
      this.changedPopupText('startdateTooltip', '');
      this.changedPopupText('endateTooltip', '');
    }

    this.setState({ dateRangeError: error });
    return error;
  }

  validateStartTimeFormat() {
    let error = '';

    const re = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    if (re.test(this.entry.startTime)) {
      this.changedPopupText('starttimeTooltip', '');
    } else {
      error = 'Invalid time format';
      this.changePopupTextAndFlash('starttimeTooltip', error);
    }

    this.setState({ starttimeFormatError: error });
    return error;
  }

  validateEndTimeFormat() {
    let error = '';

    const re = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    if (re.test(this.entry.endTime)) {
      this.changedPopupText('endtimeTooltip', '');
    } else {
      error = 'Invalid time format';
      this.changePopupTextAndFlash('endtimeTooltip', error);
    }

    this.setState({ endTimeFormatError: error });
    return error;
  }

  validateStartTime() {
    let error = '';
    if (
      dateTimeHelper.convertTimeToMinutes(this.entry.startTime) <
      dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyStartTime)
    ) {
      error = `Start time must be after ${calendarConfig.dailyStartTime}`;
      this.changePopupTextAndFlash('starttimeTooltip', error);
    } else {
      this.changedPopupText('starttimeTooltip', '');
    }

    this.setState({ startTimeError: error });
    return error;
  }

  validateEndTime() {
    let error = '';
    if (
      dateTimeHelper.convertTimeToMinutes(this.entry.endTime) >
      dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyEndTime)
    ) {
      error = `End time must be before ${calendarConfig.dailyEndTime}`;
      this.changePopupTextAndFlash('endtimeTooltip', error);
    } else {
      this.changedPopupText('endtimeTooltip', '');
    }
    this.setState({ endTimeError: error });
    return error;
  }

  validateEndTimeBiggerThanStartTime() {
    let error = '';

    if (
      dateTimeHelper.convertTimeToMinutes(this.entry.startTime) >=
      dateTimeHelper.convertTimeToMinutes(this.entry.endTime)
    ) {
      error = 'End time must be later than start time';
      this.changePopupTextAndFlash('starttimeTooltip', error);
      this.changePopupTextAndFlash('endtimeTooltip', error);
    } else {
      this.changedPopupText('starttimeTooltip', '');
      this.changedPopupText('endtimeTooltip', '');
    }

    this.setState({ endTimeBiggerThanStartTimeError: error });
    return error;
  }

  validateDateAffectsOtherWeek() {
    let error = '';

    const startDateWeekNumber = dateTimeHelper.getWeekOfYearForTimeSheet(this.entry.startDate);
    const endDateWeekNumber = dateTimeHelper.getWeekOfYearForTimeSheet(this.entry.endDate);
    if (startDateWeekNumber === endDateWeekNumber) {
      this.changedPopupText('startdateTooltip', '');
      this.changedPopupText('enddateTooltip', '');
    } else {
      error = "Entry can't start and end on different weeks";
      this.changePopupTextAndFlash('startdateTooltip', error);
      this.changePopupTextAndFlash('enddateTooltip', error);
    }

    this.setState({ dateAffectsOtherWeekError: error });
    return error;
  }

  validateOverlappingEntries() {
    let error = '';
    const overlapping = this.checkOverlappingEntries();

    if (overlapping === '') {
      this.changedPopupText('startdateTooltip', '');
      this.changedPopupText('enddateTooltip', '');
    } else {
      error = `Entry overlaps an existing entry: ${overlapping}`;
      this.changePopupTextAndFlash('startdateTooltip', error);
      this.changePopupTextAndFlash('enddateTooltip', error);
    }

    this.setState({
      overlappingEntriesError: error,
    });
    return error;
  }

  checkOverlappingEntries() {
    const entryA = this.entry;
    if (entryA.startTime > entryA.endTime && entryA.endDate <= entryA.startDate) {
      entryA.endDate = dateTimeHelper.addDaysToDate(entryA.startDate, 1);
    }
    let entryB;

    for (const existingTimesheetEntry of this.state.existingTimesheetEntries) {
      entryB = existingTimesheetEntry;
      if (entryA.id !== entryB.id) {
        var overlappingTimes;

        var overlappingDates = !(entryA.endDate < entryB.startDate || entryA.startDate > entryB.endDate);

        if (overlappingDates) {
          overlappingTimes = !(
            dateTimeHelper.convertTimeToMinutes(entryA.endTime) <
              dateTimeHelper.convertTimeToMinutes(entryB.startTime) + 1 ||
            dateTimeHelper.convertTimeToMinutes(entryA.startTime) + 1 >
              dateTimeHelper.convertTimeToMinutes(entryB.endTime)
          );

          if (overlappingTimes) {
            return `${entryB.startDate} - ${entryB.endDate} ${entryB.startTime}-${entryB.endTime} ${entryB.taskName}`;
          }
        }
      }
    }
    return '';
  }

  validateTask() {
    let error = '';

    if (this.entry.taskId === -1 || this.entry.taskId === null || this.entry.taskId === undefined) {
      error = 'Task is mandatory';
      this.changePopupTextAndFlash('taskTooltip', error);
    } else {
      this.changedPopupText('taskTooltip', '');
    }

    this.setState({
      missingTaskError: error,
    });

    return error;
  }

  ValidateLabelling(resourceType) {
    switch (resourceType) {
      case 'lead':
        this.validateLead();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'client':
        this.validateClient();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'project':
        this.validateProject();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'tpproject':
        this.validateTpProject();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'opportunity':
        this.validateOpportunity();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'survey':
        this.validateSurvey();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'tpsurvey':
        this.validateTpSurvey();
        this.validateNotOnlyLeadSelectedError();
        break;
      case 'isoutsourced':
        break;
      default:
        break;
    }
  }

  validateAllLabelling() {
    this.validateComment();
    this.validateLead();
    this.validateClient();
    this.validateProject();
    this.validateTpProject();
    this.validateOpportunity();
    this.validateSurvey();
    this.validateTpSurvey();
    this.validateNotOnlyLeadSelectedError();
  }

  validateComment() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isCommentMandatory &&
      (this.entry.comment === '' || this.entry.comment === null || this.entry.comment === undefined)
    ) {
      error = 'Comment is mandatory';
      this.changePopupTextAndFlash('commentTooltip', error);
    } else {
      this.changedPopupText('commentTooltip', '');
    }

    this.setState({
      missingCommentError: error,
    });

    return error;
  }

  validateBilledOffice() {
    // The billed office selector is shown (and mandatory) for outsourced employees,
    // or for any entry where the "Outsourced Activity?" checkbox is ticked.
    if (!this.state.isOutsourcedEmployee && !this.entry.isOutsourced) return '';

    let error = '';
    if (!this.entry.billedOfficeId) {
      error = 'Billed Office is mandatory';
      this.changePopupTextAndFlash('billedOfficeTooltip', error);
    } else if (this.entry.isOutsourced && String(this.entry.billedOfficeId) === String(this.userOfficeId)) {
      // An outsourced activity is billed to a DIFFERENT office than the one supplying the work: the collection
      // job requires CurrentOfficeId != BilledOfficeId, so an entry billed to your own office would be saved and
      // then silently never collected. Refuse it here rather than let it disappear.
      error = 'Billed Office must be an office other than your own for an outsourced activity';
      this.changePopupTextAndFlash('billedOfficeTooltip', error);
    } else {
      this.changedPopupText('billedOfficeTooltip', '');
    }

    this.setState({
      missingBilledOfficeError: error,
    });

    return error;
  }

  validateLead() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isLeadMandatory &&
      (this.entry.leadId === null || this.entry.leadId === -1 || this.entry.leadId === undefined)
    ) {
      error = 'Lead is mandatory';
      this.changePopupTextAndFlash('leadTooltip', error);
    } else if (
      this.entry.leadId !== null &&
      this.entry.leadId !== -1 &&
      this.entry.leadId !== undefined &&
      this.entry.leadName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('leadTooltip', this.entry.leadName);
    } else {
      this.changedPopupText('leadTooltip', '');
    }

    this.setState({
      missingLeadError: error,
    });

    return error;
  }

  validateClient() {
    let error = '';

    const task = this.getCurrentTask();

    // Ticking "Outsourced Activity?" deliberately does NOT force a client any more: an outsourced entry may be
    // labelled with nothing at all, in which case every office is billable. The same holds for the two project
    // fields below. Labelling only narrows the billed-office choice - it is never a precondition for it.
    if (
      task !== undefined &&
      task.isClientMandatory &&
      (this.entry.clientId === null || this.entry.clientId === undefined)
    ) {
      error = 'Client is mandatory';
      this.changePopupTextAndFlash('clientTooltip', error);
    } else if (
      this.entry.clientId !== null &&
      this.entry.clientId !== undefined &&
      this.entry.clientName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('clientTooltip', this.entry.clientName);
    } else {
      this.changedPopupText('clientTooltip', '');
    }

    this.setState({
      missingClientError: error,
    });

    return error;
  }

  validateProject() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isProjectMandatory &&
      (this.entry.projectId === null || this.entry.projectId === undefined) &&
      (this.entry.cfId === null || this.entry.cfId === undefined)
    ) {
      error = 'Project is mandatory';
      this.changePopupTextAndFlash('projectTooltip', error);
    } else if (
      this.entry.cfId !== null &&
      this.entry.cfId !== undefined &&
      this.entry.cfName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('projectTooltip', this.entry.cfName);
    } else {
      this.changedPopupText('projectTooltip', '');
    }

    this.setState({
      missingProjectError: error,
    });

    return error;
  }

  validateTpProject() {
    let error = '';
    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isTpProjectMandatory &&
      (this.entry.projectId === null || this.entry.projectId === undefined) &&
      (this.entry.cfId === null || this.entry.cfId === undefined)
    ) {
      error = 'TP Project is mandatory';
      this.changePopupTextAndFlash('tpProjectTooltip', error);
    } else if (
      this.entry.projectId !== null &&
      this.entry.projectId !== undefined &&
      this.entry.projectName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('tpProjectTooltip', this.entry.projectName);
    } else {
      this.changedPopupText('tpProjectTooltip', '');
    }
    this.setState({
      missingTpProjectError: error,
    });
    return error;
  }

  validateOpportunity() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isOpportunityMandatory &&
      (this.entry.opportunityId === null || this.entry.opportunityId === undefined)
    ) {
      error = 'Opportunity is mandatory';
      this.changePopupTextAndFlash('opportunityTooltip', error);
    } else if (
      this.entry.opportunityId !== null &&
      this.entry.opportunityId !== undefined &&
      this.entry.opportunityName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('opportunityTooltip', this.entry.opportunityName);
    } else {
      this.changedPopupText('opportunityTooltip', '');
    }

    this.setState({
      missingOpportunityError: error,
    });

    return error;
  }

  validateSurvey() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isSurveyMandatory &&
      (this.entry.surveyId === null || this.entry.surveyId === undefined) &&
      (this.entry.tpSurveyId === null || this.entry.tpSurveyId === undefined)
    ) {
      error = 'Survey is mandatory';
      this.changePopupTextAndFlash('surveyTooltip', error);
    } else if (
      this.entry.surveyId !== null &&
      this.entry.surveyId !== undefined &&
      this.entry.surveyName &&
      this.entry.surveyName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('surveyTooltip', this.entry.surveyName);
    } else {
      this.changedPopupText('surveyTooltip', '');
    }

    this.setState({
      missingSurveyError: error,
    });

    return error;
  }

  validateTpSurvey() {
    let error = '';

    const task = this.getCurrentTask();

    if (
      task !== undefined &&
      task.isTpSurveyMandatory &&
      (this.entry.surveyId === null || this.entry.surveyId === undefined) &&
      (this.entry.tpSurveyId === null || this.entry.tpSurveyId === undefined)
    ) {
      error = 'TP Survey is mandatory';
      this.changePopupTextAndFlash('tpSurveyTooltip', error);
    } else if (
      this.entry.tpSurveyId !== null &&
      this.entry.tpSurveyId !== undefined &&
      this.entry.tpSurveyName &&
      this.entry.tpSurveyName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('tpSurveyTooltip', this.entry.tpSurveyName);
    } else {
      this.changedPopupText('tpSurveyTooltip', '');
    }

    this.setState({
      missingTpSurveyError: error,
    });

    return error;
  }

  validateNotOnlyLeadSelectedError() {
    let error = '';
    const e = this.entry;

    if (
      e.leadId != null &&
      e.leadId !== -1 &&
      (e.clientId != null ||
        e.cfId != null ||
        e.projectId != null ||
        e.opportunityId != null ||
        e.surveyId != null ||
        e.tpSurveyId != null)
    ) {
      error = 'Selecting a lead with client / project / tp project / opportunity / survey / tp survey is not possible.';
      this.changePopupTextAndFlash('leadTooltip', error);
    } else if (
      this.entry.leadId !== null &&
      this.entry.leadId !== -1 &&
      this.entry.leadId !== undefined &&
      this.entry.leadName.length > this.showLabelingTextMaxLength
    ) {
      this.changedPopupText('leadTooltip', this.entry.leadName);
    } else {
      this.changedPopupText('leadTooltip', '');
    }

    this.setState({
      notOnlyLeadSelectedError: error,
    });

    return error;
  }

  hideAllTooltip() {
    $('[data-toggle="startdateTooltip"]').tooltip('hide');
    $('[data-toggle="endtdateTooltip"]').tooltip('hide');
    $('[data-toggle="starttimeTooltip"]').tooltip('hide');
    $('[data-toggle="enddateTooltip"]').tooltip('hide');
    $('[data-toggle="taskTooltip"]').tooltip('hide');
    $('[data-toggle="commentTooltip"]').tooltip('hide');
    $('[data-toggle="leadTooltip"]').tooltip('hide');
    $('[data-toggle="clientTooltip"]').tooltip('hide');
    $('[data-toggle="projectTooltip"]').tooltip('hide');
    $('[data-toggle="tpProjectTooltip"]').tooltip('hide');
    $('[data-toggle="opportunityTooltip"]').tooltip('hide');
    $('[data-toggle="surveyTooltip"]').tooltip('hide');
    $('[data-toggle="tpSurveyTooltip"]').tooltip('hide');
    $('[data-toggle="tooltip"]').tooltip('hide');
  }

  changedPopupText(tooltipName, newTitle) {
    if (newTitle === '') {
      $(`[data-toggle="${tooltipName}"]`).tooltip('hide');
      $(`[data-toggle="${tooltipName}"]`).tooltip('disable');
    } else {
      $(`[data-toggle="${tooltipName}"]`).tooltip('enable');
      $(`[data-toggle="${tooltipName}"]`).attr('title', newTitle).tooltip('_fixTitle');
    }
  }

  changePopupTextAndFlash(tooltipName, newTitle) {
    $(`[data-toggle="${tooltipName}"]`).tooltip('enable');
    $(`[data-toggle="${tooltipName}"]`).attr('title', newTitle).tooltip('_fixTitle');
    $(`[data-toggle="${tooltipName}"]`).tooltip('show');
    setTimeout(() => {
      $(`[data-toggle="${tooltipName}"]`).tooltip('hide');
    }, 2000);
  }

  getCurrentTask() {
    return this.state.taskList.find((task) => {
      return task.value === this.entry.taskId;
    });
  }

  clearLabelling(resourceType) {
    const modifiedTimeSheetEntry = this.entry;

    switch (resourceType) {
      case 'lead':
        modifiedTimeSheetEntry.leadName = '';
        modifiedTimeSheetEntry.leadId = -1;
        break;
      case 'client':
        modifiedTimeSheetEntry.clientName = '';
        modifiedTimeSheetEntry.clientId = null;
        modifiedTimeSheetEntry.opportunityName = '';
        modifiedTimeSheetEntry.opportunityId = null;
        modifiedTimeSheetEntry.cfName = '';
        modifiedTimeSheetEntry.cfId = null;
        modifiedTimeSheetEntry.projectName = '';
        modifiedTimeSheetEntry.projectId = null;
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.surveyId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        break;
      case 'opportunity':
        modifiedTimeSheetEntry.opportunityName = '';
        modifiedTimeSheetEntry.opportunityId = null;
        modifiedTimeSheetEntry.cfName = '';
        modifiedTimeSheetEntry.cfId = null;
        modifiedTimeSheetEntry.projectName = '';
        modifiedTimeSheetEntry.projectId = null;
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.surveyId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        break;
      case 'project':
        modifiedTimeSheetEntry.cfName = '';
        modifiedTimeSheetEntry.cfId = null;
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.surveyId = null;
        break;
      case 'tpproject':
        modifiedTimeSheetEntry.projectName = '';
        modifiedTimeSheetEntry.projectId = null;
        modifiedTimeSheetEntry.tpSurveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        break;
      case 'survey':
        modifiedTimeSheetEntry.surveyName = '';
        modifiedTimeSheetEntry.surveyId = null;
        break;
      case 'tpsurvey':
        modifiedTimeSheetEntry.tpSurveyName = '';
        modifiedTimeSheetEntry.tpSurveyId = null;
        break;
      case 'servicetype':
        modifiedTimeSheetEntry.serviceType = '';
        break;
      case 'isoutsourced':
        break;
      default:
        break;
    }

    this.setState({
      timesheetEntry: modifiedTimeSheetEntry,
    });
  }

  saveTimesheetEntry() {
    // Block outsourced employees with no FTE entries (unless they ticked Outsourced Activity, which is partial outsourcing unrelated to FTE)
    if (this.state.isOutsourcedEmployee && this.state.noFteEntries && !this.entry.isOutsourced) {
      ErrorMessage.SetWarning(
        'FTE tracking is not set up for the current month. Please contact your HR representative or line manager to set up FTE tracking before submitting Activity Tracker entries.'
      );
      return;
    }

    this.entry.endDate = this.entry.startDate;
    if (
      !this.validateDateRange() &&
      !this.validateEndTimeBiggerThanStartTime() &&
      !this.validateStartTimeFormat() &&
      !this.validateEndTimeFormat() &&
      !this.validateStartTime() &&
      !this.validateEndTime() &&
      !this.validateOverlappingEntries() &&
      !this.validateTask() &&
      !this.validateBilledOffice() &&
      !this.validateLead() &&
      !this.validateClient() &&
      !this.validateProject() &&
      !this.validateTpProject() &&
      !this.validateOpportunity() &&
      !this.validateSurvey() &&
      !this.validateTpSurvey() &&
      !this.validateNotOnlyLeadSelectedError() &&
      !this.validateComment() &&
      dateTimeHelper.isItAValidTime(this.state.timesheetEntry.startTime) &&
      dateTimeHelper.isItAValidTime(this.state.timesheetEntry.endTime)
    ) {
      const entryEndWeekDay = dateTimeHelper.getWeekDay(this.entry.endDate);

      if (entryEndWeekDay === 'Saturday' || entryEndWeekDay === 'Sunday') {
        ErrorMessage.SetApprove(
          'Entry contains weekend hours. Are you sure you want to create it?',
          this.saveTimesheetEntryForWeekend.bind(this)
        );
      } else {
        TimeSheetEntryService.SaveTimesheetEntry(this.entry)
          .then((result) => {
            if (result.error) {
              ErrorMessage.SetWarning(result.error);
              return;
            }
            ErrorMessage.SetNotification('Entry saved');
            this.props.RefreshEntryList();
          })
          .catch((error) => {
            ErrorMessage.SetErrorMessage('TSEE1778', error);
          });
        this.hideAllTooltip();
        this.props.closeEditorPopup();
      }
    }
  }

  saveTimesheetEntryForWeekend() {
    TimeSheetEntryService.SaveTimesheetEntry(this.entry)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetNotification('Entry saved');
        this.props.RefreshEntryList();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TSEE1796');
      });
    this.hideAllTooltip();
    this.props.closeEditorPopup();
  }

  deleteTimesheetEntry() {
    TimeSheetEntryService.DeleteTimesheetEntry(this.entry)
      .then((result) => {
        ErrorMessage.SetNotification('Entry has been deleted.');
        this.props.RefreshEntryList();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TSEE1808'));
    this.hideAllTooltip();
    this.props.closeEditorPopup();
  }

  copyEntry() {
    const modifiedTimeSheetEntry = this.entry;
    modifiedTimeSheetEntry.id = '';
    this.setState({
      timesheetEntry: modifiedTimeSheetEntry,
      starttimeFormatError: 'Invalid time format',
      endtimeFormatError: 'Invalid time format',
    });
  }

  // Copy turns the editor into a new entry for the ORIGINAL owner, and the backend rejects
  // creating entries for other users — so hide that dead end when HR/Admin opened someone
  // else's entry.
  isOtherUsersEntry() {
    const tsUser = AuthService.getInstance().GetTimesheetUser();
    return !!(this.entry.userId && tsUser && this.entry.userId !== tsUser.userId);
  }
}
